// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/fast-forward.svg';

export const FastForward = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
